export const leadScoreSelector = (state) => state.leadScoreReducer;
